/**
 * A card's answer: what the clinician sees as their message and what c3 receives. Pure; each
 * card decides what a pick holds, this only shapes the answer around it.
 */

export const OTHER_MAX = 500;

/** One question's answer: its picks and any typed words. */
export function selection(question, chosen, other) {
  const typed = (other || "").trim().slice(0, OTHER_MAX);
  return {
    header: question.header,
    question: question.question,
    chosen,
    other: typed || null,
  };
}

export function isAnswered(answer) {
  return answer.chosen.length > 0 || Boolean(answer.other);
}

/** The bubble: "Client: Rivera, Ana · Period: Last month"; typed words kept verbatim. */
export function answerText(answers) {
  return answers
    .map((a) => {
      const said = [...a.chosen.map((c) => c.name || c), a.other]
        .filter(Boolean)
        .join(", ");
      return answers.length > 1 ? `${a.header}: ${said}` : said;
    })
    .join(" · ");
}

export function interactionResponse(card, answers) {
  return {
    interaction_id: card.id,
    type: card.type,
    values: { selections: answers },
  };
}
